import { UAParser } from "ua-parser-js";
import { connect as connectToInstagram } from "./instagram";

const uaParser = new UAParser();
const device = uaParser.getDevice();

export const connectToProvider = (
  providerTag: "facebook" | "instagram" | "google_photos"
): Promise<string | void> => {
  if (providerTag === "instagram") {
    return connectToInstagram();
  } else {
    return new Promise<void>((resolve, reject) => {
      const connectUrl = `/users/auth/${providerTag}`;

      window.oAuthSuccess = () => {
        resolve();
      };

      window.oAuthError = () => {
        reject(new Error(`oAuth with ${providerTag} failed`));
      };

      // Fallback just in case we don't have window.opener
      try {
        localStorage.setItem("oAuthRedirectUrl", window.location.href);
      } catch (e) {
        // do nothing
      }

      if (device.type === "mobile" || device.type === "tablet") {
        // Using "_blank" is important to have the window.opener on some devices (Chrome iOS)
        // window.open must have no other params.
        // Be sure that it is called from a click event.
        window.open(connectUrl, "_blank");
      } else {
        window.open(connectUrl, "OAuth", "width=500, height=500");
      }
    }).finally(() => {
      window.focus();

      // Cleaning
      try {
        localStorage.removeItem("oAuthRedirectUrl");
      } catch (e) {
        // do nothing
      }

      delete window.oAuthSuccess;
      delete window.oAuthError;
    });
  }
};
